import Glide from '@glidejs/glide'

export default () => {
  return {
    slider: null,
    index: 1,
    init() {
      this.slider = new Glide(this.$el,
        {
          type: 'carousel',
          autoplay: 6000,
          perView: 4,
          loop: true,
          startAt: 1,
          focusAt: 2,
          gap: 32,
          breakpoints: {
            680: {
              perView: 1,
            },
            1023: {
              focusAt: 1,
              perView: 2,
            },
            1200: {
              perView: 3,
            },
          },
        })
        this.slider.on('run', () => {
          this.index = this.slider.index
        })
      this.slider.mount()
    },
  }
}
